/*
 * Copyright 2022, TeamDev. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Redistribution and use in source and/or binary forms, with or without
 * modification, must retain the above copyright notice and the following
 * disclaimer.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Type: true,
  TypedMessage: true,
  TypeUrl: true,
  ActorRequestFactory: true,
  ActorProvider: true,
  Filters: true,
  FirebaseDatabaseClient: true,
  HttpClient: true,
  Client: true,
  init: true,
  TenantIds: true,
  TenantProvider: true,
  Duration: true
};
Object.defineProperty(exports, "ActorProvider", {
  enumerable: true,
  get: function get() {
    return _actorRequestFactory.ActorProvider;
  }
});
Object.defineProperty(exports, "ActorRequestFactory", {
  enumerable: true,
  get: function get() {
    return _actorRequestFactory.ActorRequestFactory;
  }
});
Object.defineProperty(exports, "Client", {
  enumerable: true,
  get: function get() {
    return _client.Client;
  }
});
Object.defineProperty(exports, "Duration", {
  enumerable: true,
  get: function get() {
    return _timeUtils.Duration;
  }
});
Object.defineProperty(exports, "Filters", {
  enumerable: true,
  get: function get() {
    return _actorRequestFactory.Filters;
  }
});
Object.defineProperty(exports, "FirebaseDatabaseClient", {
  enumerable: true,
  get: function get() {
    return _firebaseDatabaseClient.FirebaseDatabaseClient;
  }
});
Object.defineProperty(exports, "HttpClient", {
  enumerable: true,
  get: function get() {
    return _httpClient.HttpClient;
  }
});
Object.defineProperty(exports, "TenantIds", {
  enumerable: true,
  get: function get() {
    return _tenant.TenantIds;
  }
});
Object.defineProperty(exports, "TenantProvider", {
  enumerable: true,
  get: function get() {
    return _tenant.TenantProvider;
  }
});
Object.defineProperty(exports, "Type", {
  enumerable: true,
  get: function get() {
    return _typedMessage.Type;
  }
});
Object.defineProperty(exports, "TypeUrl", {
  enumerable: true,
  get: function get() {
    return _typedMessage.TypeUrl;
  }
});
Object.defineProperty(exports, "TypedMessage", {
  enumerable: true,
  get: function get() {
    return _typedMessage.TypedMessage;
  }
});
Object.defineProperty(exports, "init", {
  enumerable: true,
  get: function get() {
    return _spine.init;
  }
});

var _typedMessage = require("./client/typed-message");

var _actorRequestFactory = require("./client/actor-request-factory");

var _firebaseDatabaseClient = require("./client/firebase-database-client");

var _httpClient = require("./client/http-client");

var _client = require("./client/client");

var _spine = require("./client/spine");

var _tenant = require("./client/tenant");

var _errors = require("./client/errors");

Object.keys(_errors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _errors[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _errors[key];
    }
  });
});

var _timeUtils = require("./client/time-utils");
//# sourceMappingURL=index.js.map